import React from "react";

const UserContext = React.createContext({
  userId: null,
  userEmail: null,
  isAdmin: null,
  userRoles: null,
  selectedClientFiscalCode: null,
  selectedClientName: null,
  selectedClientTwoFactorEnabled: null,
  twoFactorAuthResendToken: null,
  isAIModuleAllowed: false,
  isEfModuleAllowed: false,
  isAuthModuleAllowed: false,
  isStatisticModuleAllowed: false,
  setSelectedClientFiscalCode: () => {},
  setSelectedClientName: () => {},
  setSelectedClientTwoFactorEnabled: () => {},
  setIsAdmin: () => {},
  setUserRoles: () => {},
  setUserEmail: () => {},
  setUserId: () => {},
  setTwoFactorAuthResendToken: () => {},
  setIsEfModuleAllowed: () => {},
  setIsAIModuleAllowed: () => {},
  setIsAuthModuleAllowed: () => {},
  setIsStatisticModuleAllowed: () => {},
});

export default UserContext;
